export interface バーコードブック帳票商品型 {
    商品区分: string;
    使用区分: string;
    JANコード: string;
    販売GTINコード: string;
    備蓄商品コード: string;
    JAN販売GTIN備蓄商品コード: string;
    メーカー名: string;
    商品名: string;
    規格容量: string;
}

export interface バーコードブック取込結果型 {
    バーコードブック取込結果区分: string;
    バーコードブック帳票商品一覧: バーコードブック帳票商品型[];
}

export enum バーコードブック取込結果区分 {
    取込に成功しました = '取込に成功しました',
    一部の商品は採用品に存在しないため取り込めませんでした = '一部の商品は、採用品に存在しないため取り込めませんでした',
    取込可能な商品がありません = '取込可能な商品がありません',
}
